import {Injectable} from '@angular/core';
import {Effect, Actions} from '@ngrx/effects';
import * as freelancerAction from '../actions/freelancer.action';
import {map, switchMap, catchError, mergeMap, take, withLatestFrom, filter} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {Action, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import {FreelancersService} from '../../freelancers.service';
import {isNullOrUndefined} from 'util';
import * as fromStore from '../../../store';

@Injectable()
export class FreelancerEffect {
  constructor(private actions: Actions,
              private store: Store<fromStore.AppState>,
              private freelancerService: FreelancersService) {
  }

  @Effect()
  getAllFreelancers: Observable<Action> = this.actions.ofType(freelancerAction.GET_ALL_FREELANCERS)
    .pipe(
      switchMap(() => {
        return this.freelancerService.getAllFreelancers()
          .map(res => new freelancerAction.GetAllFreelancersSuccess(res))
          .catch(error => of(new freelancerAction.GetAllFreelancersError(error)));
      })
    );
  @Effect()
  getFreelancer: Observable<Action> = this.actions.ofType(freelancerAction.GET_FREELANCER)
    .pipe(
      withLatestFrom(
        // select users.
        this.store.select(state => state.freelancersFeature.freelancers),
        (action: any, freelancers) => {
          // if no users present, proceed for API.
          if (isNullOrUndefined(freelancers.users)) {
            return action;
          } else {
            // users exists in store.
            const user = freelancers.users.filter(f => f.id === action.payload)[0];
            if (!!user) {
              // if required user is present in store, then return;
              return undefined;
            } else {
              // if required user not present in store, then proceed for API.
              return action;
            }
          }
        }
      ),
      filter(action => !!action),
      mergeMap(action => {
        return this.freelancerService.getFreelancer(action.payload)
          .map(res => new freelancerAction.GetFreelancerSuccess(res))
          .catch(error => of(new freelancerAction.GetFreelancerError(error)));
      })
    );

  @Effect()
  registerFreelancer: Observable<Action> = this.actions.ofType(freelancerAction.ADD_FREELANCER)
    .map((action: freelancerAction.AddFreelancer) => action.payload)
    .pipe(
      switchMap(body => {
        return this.freelancerService.registerFreelancer(body)
          .map(res => new freelancerAction.AddFreelancerSuccess(res))
          .catch(error => of(new freelancerAction.AddFreelancerError(error)));
      })
    );

  @Effect()
  updateFreelancer: Observable<Action> = this.actions.ofType(freelancerAction.UPDATE_FREELANCER)
    .map((action: freelancerAction.UpdateFreelancer) => action.payload)
    .pipe(
      switchMap(body => {
        return this.freelancerService.updateFreelancer(body)
          .map(res => new freelancerAction.UpdateFreelancerSuccess(res))
          .catch(error => of(new freelancerAction.UpdateFreelancerError(error)));
      })
    );

  @Effect()
  deleteFreelancer: Observable<Action> = this.actions.ofType(freelancerAction.DELETE_FREELANCER)
    .map((action: freelancerAction.DeleteFreelancer) => action.payload)
    .pipe(
      switchMap(body => {
        return this.freelancerService.deleteFreelancer(body)
          .map(res => new freelancerAction.DeleteFreelancerSuccess(res))
          .catch(error => of(new freelancerAction.DeleteFreelancerError(error)));
      })
    );
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/freelancers/store/effects/freelancer.effect.ts